import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import parse from 'html-react-parser';
//@ts-ignore
import * as styles from './trustpilot.module.css';

interface Props {
    code: {
        value: string;
    };
    kontentItemId?: string;
}
const TRUSTPILOT_SRC =
    '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

const TrustPilot: React.FC<Props> = ({ code, kontentItemId }) => {
    useEffect(() => {
        if (typeof window.ketch !== 'function') return;
        window.ketch('on', 'consent', (consent: any) => {
            if (!consent.purposes.essential_services) return;
            if (document.querySelector(`script[src="${TRUSTPILOT_SRC}"]`))
                return;
            const script = document.createElement('script');
            script.src = TRUSTPILOT_SRC;
            script.async = true;
            document.head.appendChild(script);
        });
    }, []);
    let html = code.value;
    html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    html = html.replace(/\n/g, '');
    let processedHtmlTags = parse(html);
    return (
        <>
            <div
                className={styles.reviews}
                data-kontent-item-id={kontentItemId}
            >
                {processedHtmlTags}
            </div>
        </>
    );
};
export default TrustPilot;
export const fragmentTrustPilot = graphql`
    fragment TrustPilot on kontent_item_component___trust_pilot_reviews {
        elements {
            code {
                value
            }
        }
    }
`;
